/** @jsxImportSource @emotion/react */
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { accessAPI, formatFecha, TablaFiltrable } from "../../shared";

import { Accordion, AccordionTab } from "primereact/accordion";
import { Column } from "primereact/column";
import { Skeleton } from "primereact/skeleton";

const SEARCH_FIELDS = ["numeroEnsayo", "cliente", "proceso", "actividad", "asignadosTexto"];

// Fecha local de hoy como YYYY-MM-DD, para el nombre del Excel.
function fechaDeHoy() {
  const hoy = new Date();
  const dos = (n) => String(n).padStart(2, "0");
  return `${hoy.getFullYear()}-${dos(hoy.getMonth() + 1)}-${dos(hoy.getDate())}`;
}

// Actividades cuyo paso actual es de tipo Ensayo, tengan o no a alguien
// asignado.
export default function ActividadesEnEnsayo({ toast }) {
  const [pasos, setPasos] = useState();
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    accessAPI(
      "GET",
      "admin/destacados/actividadesenensayo",
      null,
      (respuesta) => {
        setPasos(
          respuesta.map((p) => ({
            ...p,
            asignadosTexto: p.asignados.join(", ")
          }))
        );
        setLoading(false);
      },
      (respuesta) => {
        toast.current.show({
          severity: "error",
          summary: "Error",
          detail: respuesta[0]?.msg || "Error al cargar actividades en ensayo",
          sticky: true
        });
        setLoading(false);
      }
    );
  }, [toast]);

  if (loading) {
    return (
      <div css={{ marginTop: "1em" }}>
        <Skeleton width="100%" height="3.5rem" borderRadius="6px" />
      </div>
    );
  }

  if (!pasos || pasos.length === 0) {
    return null;
  }

  return (
    <Accordion
      activeIndex={null}
      css={{
        marginTop: "1em",
        "& .p-accordion-header-link": { color: "black" },
        "& .p-toggleable-content": { transition: "max-height 0.15s ease" }
      }}
    >
      <AccordionTab header={`Ensayos en curso (${pasos.length})`}>
        <TablaFiltrable
          value={pasos}
          searchFields={SEARCH_FIELDS}
          anchoBusqueda="33%"
          nombreArchivo={`Ensayos en curso - ${fechaDeHoy()}`}
          emptyMessage="No hay ensayos en curso"
          size="small"
          rows={10}
          onRowClick={(e) => {
            if (e.originalEvent.metaKey || e.originalEvent.ctrlKey) {
              window.open(e.data.link, "_blank");
            } else {
              navigate(e.data.link);
            }
          }}
          css={{ "& .p-datatable-tbody > tr": { cursor: "pointer" } }}
        >
          <Column
            header="N° de ensayo"
            field="numeroEnsayo"
            body={(p) => p.numeroEnsayo ?? "—"}
          />
          <Column header="Cliente" field="cliente" />
          <Column header="Proceso" field="proceso" />
          <Column header="Actividad" field="actividad" />
          <Column
            header="Inicio del paso"
            field="fechaInicioPaso"
            body={(p) => (p.fechaInicioPaso ? formatFecha(p.fechaInicioPaso) : "—")}
          />
          <Column
            header="Asignado a"
            field="asignadosTexto"
            body={(p) => p.asignadosTexto || "Sin asignar"}
          />
        </TablaFiltrable>
      </AccordionTab>
    </Accordion>
  );
}
